import { useState } from "react";
import toast from "react-hot-toast";
import { updateRetestStatus } from "../../../utils/api/endpoints/retests/retests";

const useCommentForm = (
  retest_id: string | undefined,
  role: string,
  refetchLogs: () => void
) => {
  const [comment, setComment] = useState<string>("");
  const [selectedStatus, setSelectedStatus] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [pocFile, setPocFile] = useState<File | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleCommentSubmit = async (actionTaken: string, comment: string) => {
    if (!retest_id) {
      toast.error("Retest ID is undefined");
      return;
    }

    try {
      if (!selectedStatus || !actionTaken || !comment) {
        toast.error("All fields are required");
        return;
      }

      setIsSubmitting(true);
      setError(null);

      const statusBeforeUpdate = selectedStatus;

      await updateRetestStatus(
        retest_id,
        selectedStatus,
        actionTaken,
        comment,
        pocFile || undefined
      );

      // Reset the form
      setComment("");
      setSelectedStatus("");
      setPocFile(null);
      setError(null);
      setIsSubmitting(false);

      // Show success toast with appropriate message
      if (statusBeforeUpdate === "chat") {
        toast.success("Your message has been sent successfully!");
      } else {
        toast.success(`Status updated to "${statusBeforeUpdate}" successfully!`);
      }

      // Trigger a re-fetch of logs
      refetchLogs();
    } catch (error: any) {
      console.error("Error submitting comment:", error);
      toast.error(error.message || "An error occurred");
      setIsSubmitting(false);
    }
  };

  return {
    comment,
    setComment,
    selectedStatus,
    setSelectedStatus,
    pocFile,
    setPocFile,
    handleCommentSubmit,
    error,
    setError,
    isSubmitting
  };
};

export default useCommentForm;
